export const paths = {
  privacy: () => '/privacy',
  about: () => '/about',
}
